module.exports = __webpack_public_path__ + "img/order.500e32ac.png";